import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainGetAccessControlInfoByQrcodeId(qrcodeId) {
  return maintainRequest.post(
    `/device/common/device/getDeviceInfoByQrCodeId/${qrcodeId}`
  );
}
